module.exports = __webpack_public_path__ + "h5/img/bei.5c890da4.png";